import Vue from 'vue'
import axios from 'axios'
import { store } from '@/store/store'

const axiosinstance = axios.create()
axiosinstance.interceptors.request.use(
    function (config) {
        config.baseURL = process.env.WEBAPI_ENDPOINT
        config.withCredentials = true
        return config
    },
    function (error) {
        return Promise.reject(error)
    }
)

export default {
    get (url, request) {
        return axiosinstance.get(url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error))
    },
    post (url, request) {
        return axiosinstance.post(url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => {
                if (store.getters.userInfo.userId !== null) {
                    if (error.response.status === 401) {
                        Vue.prototype.$notify({
                            group: 'info',
                            type: 'error',
                            text: 'Noget gik galt, prøv at logge ud og ind igen'
                        })
                    } else {
                        Vue.prototype.$notify({
                            group: 'info',
                            type: 'error',
                            text: 'Noget gik galt, prøv igen (fejlkode: ' + error.response.status + ')'
                        })
                        console.error('error.response.status', error.response.status)
                    }
                }
                return Promise.reject(error)
            })
    },
    patch (url, request) {
        return axiosinstance.patch(url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error))
    },
    delete (url, request) {
        return axiosinstance.delete(url, request)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error))
    },
    getfeed (url, request) {
        return axiosinstance.get(url, {params: request})
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error))
    }
}



// WEBPACK FOOTER //
// ./src/store/api.js